import { AsyncPipe, KeyValuePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { FilterOptions } from '@app/layout/filter/interfaces/filter-options';
import { GallerySelectors, ToggleContentTypeFilterValue } from '@app/store';
import { Store } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { contenTypeFilterOptions } from './content-type-filter-options';
import { ContentTypeFilterValues } from './content-type-filter-values';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationExtras } from '@angular/router';
import { Navigate } from '@ngxs/router-plugin';

@Component({
  selector: 'app-content-type-filter',
  templateUrl: './content-type-filter.component.html',
  styleUrls: ['./content-type-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, KeyValuePipe],
})
export class ContentTypeFilterComponent implements OnInit {
  constructor(
    private store: Store,
    private destroyRef: DestroyRef,
  ) {}

  // Value
  protected value$: Observable<ContentTypeFilterValues[]> = this.store.select(
    GallerySelectors.type,
  );

  // Options
  protected options: FilterOptions<ContentTypeFilterValues> =
    contenTypeFilterOptions;

  protected ContentTypeFilterValues = ContentTypeFilterValues;

  ngOnInit(): void {
    this.value$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((type: ContentTypeFilterValues[]) => {
          let typeValue = '';

          if (type.length > 0) {
            const predefinedOrder = Array.from(contenTypeFilterOptions.keys());
            const sortedType = type
              .slice()
              .sort(
                (a, b) =>
                  predefinedOrder.indexOf(a) - predefinedOrder.indexOf(b),
              );
            typeValue = sortedType.join(',');
          }

          const extras: NavigationExtras = {
            queryParams: typeValue ? { type: typeValue } : { type: null },
            queryParamsHandling: 'merge',
          };
          this.store.dispatch(new Navigate([], [], extras));
        }),
      )
      .subscribe();
  }

  protected onToggle(value: string): void {
    this.store.dispatch(
      new ToggleContentTypeFilterValue(value as ContentTypeFilterValues),
    );
  }

  protected asContentTypeFilterValues(value: any): ContentTypeFilterValues {
    return value as ContentTypeFilterValues;
  }
}
